module.exports = "../dist/img/upper-banner-23.0fff.jpg";